@import '../../styles/mixins/_btalk-mixins.scss';
@import '../../styles/variables/_btalk-variables.scss';
@import '../../styles/classes.scss';
@import '../../styles/buttons.scss';
@import '../../styles/header-nav.scss';

.btalk-nav {

  li,
  li li {
    list-style: none;
  }
}


